module.exports = __webpack_public_path__ + "img/U1F94E.6e398968.png";